import { Lightbox } from './ligthbox.component';
export default Lightbox;
